module.exports = __webpack_public_path__ + "img/img13.86cae99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/01/img13.png
// module id = 168
// module chunks = 0